const accountGroupsRootState = {
    parent: 'root',
    url: '/accountGroups',
    abstract: true,
    template: '<ui-view></ui-view>'
};

export default function (app) {
    app.config($stateProvider => {
        $stateProvider
            .state('accountGroups', accountGroupsRootState);
    });
}



// WEBPACK FOOTER //
// ./Client/app/accountGroups/routes.js